module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview"
  }, [(_vm.$mobile && _vm.questionToggle != null) ? _c('aside', {
    staticClass: "questionToggle",
    class: {
      'toggled': _vm.questionToggle
    },
    on: {
      "click": _vm.toggleQuestion
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    on: {
      "enter": _vm.slideinQuestion,
      "leave": _vm.slideoutQuestion
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$mobile && _vm.questionToggle === true || _vm.questionToggle != false),
      expression: "$mobile && questionToggle === true || questionToggle != false"
    }],
    staticClass: "introtext-container",
    class: {
      'floating': _vm.$mobile && _vm.questionToggle != null, 'mobile': _vm.$mobile
    }
  }, [_c('div', {
    staticClass: "introtext",
    domProps: {
      "innerHTML": _vm._s(_vm.episode.introtext)
    },
    on: {
      "click": _vm.setupQuestionToggle
    }
  })])]), _vm._v(" "), (!_vm.$mobile) ? _c('Answers', {
    attrs: {
      "type": 'inline',
      "popup": true,
      "mod": _vm.mod
    }
  }) : _c('AnswersSlideshow', {
    attrs: {
      "mod": _vm.mod
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer",
    class: {
      'mobile': _vm.$mobile
    }
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('strong', [_vm._v(_vm._s(_vm.pointResponse))]), _c('br'), _vm._v("\n            Je hebt met deze vraag in totaal " + _vm._s(_vm.episode.points) + " punten verdiend!\n            "), _c('a', {
    staticClass: "button black right",
    class: {
      'mobile': _vm.$mobile
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.proceed($event)
      }
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('div', {
    staticClass: "points-container"
  }, [_c('div', {
    staticClass: "points"
  }, [_c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.points))])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02e1e62a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Overview.vue
// module id = 112
// module chunks = 1